/**
 * Thin wrappers around the org Cloud Functions. Web mirror of
 * `src/features/org/organizations.ts` on mobile so the call
 * signatures match exactly.
 */
import { httpsCallable } from 'firebase/functions';

import { functions } from '@/lib/firebase';

/**
 * Move the user's active org to `orgId`. Server writes
 * `users/{uid}.primaryOrgId` AND calls `refreshUserClaims` to mint a
 * fresh token reflecting the new active org. ~200ms round-trip.
 */
export async function setPrimaryOrganization(
  orgId: string,
): Promise<{ ok: true }> {
  const fn = httpsCallable<{ orgId: string }, { ok: true }>(
    functions,
    'setPrimaryOrganization',
  );
  const { data } = await fn({ orgId });
  return data;
}
